import { render, staticRenderFns } from "./HelpCenterHeader.vue?vue&type=template&id=e978aa16&scoped=true"
import script from "./HelpCenterHeader.vue?vue&type=script&lang=js"
export * from "./HelpCenterHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e978aa16",
  null
  
)

export default component.exports